import Button, {
  BUTTON_CSS_VARS
} from "@pathwright/ui/src/components/button/Button"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import { useQuery } from "@pathwright/web/src/modules/utils/apollo"
import get from "lodash/get"
import styled from "styled-components"
import {
  FEATURE_PERMISSION_DISABLED,
  FEATURE_PERMISSION_EVERYONE
} from "../constants"
import { CONTEXTUAL_FEATURE_PERMISSION_QUERY } from "../graphql"
import { getFeaturePermissionInfo } from "../utils"

const FeatureVisibilityIndicator = ({
  featureKey,
  featureAction,
  context,
  onClick
}) => {
  const { t } = useTranslate()
  const cfpQuery = useQuery(CONTEXTUAL_FEATURE_PERMISSION_QUERY, {
    variables: {
      featureKey,
      featureAction,
      context
    }
  })

  const permissionInContext = get(
    cfpQuery,
    "data.contextualFeaturePermission.permission_in_context"
  )

  // loading, or possibly an error, regardless, safe to return null
  if (!permissionInContext) return null
  // visibility is not limited if visible to everyone
  if (permissionInContext === FEATURE_PERMISSION_EVERYONE) return null
  // should never render component if feature is disabled, but just to be sure
  if (permissionInContext === FEATURE_PERMISSION_DISABLED) return null

  const { icon, titleAbbr } = getFeaturePermissionInfo(
    featureKey,
    permissionInContext,
    t
  )

  return (
    <StyledButton styleType="primary-alt" onClick={onClick}>
      <Container>
        <Pathicon icon={icon} />
        <span>{titleAbbr}</span>
      </Container>
    </StyledButton>
  )
}

FeatureVisibilityIndicator.displayName = FeatureVisibilityIndicator

FeatureVisibilityIndicator.propTypes = {
  ...CONTEXTUAL_FEATURE_PERMISSION_QUERY._propTypes
}

const StyledButton = styled(Button)`
  ${BUTTON_CSS_VARS.BORDER_RADIUS}: 50%;
  height: 60px;
  width: 60px;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > span {
    font-size: 0.8em;
  }
`

export default FeatureVisibilityIndicator
